import httpService from "./httpService"

export const getAllPropertiesService = (page, limit, q, type) => {
    return httpService(`/shop_admin/property_admin_panel/?page=${page}&limit=${limit}${q ? `&q=${q}` : ""}${type ? `&type=${type}` : ""}`, "get");
}

export const getSinglePropertyService = (propertyId) => {
    return httpService(`/shop_admin/property_admin_panel/${propertyId}/`, "get");
}

export const addNewPropertyService = (data) => {
    return httpService("/shop_admin/property_admin_panel/", "post", data)
}

export const editPropertyService = (propertyId, data) => {
    return httpService(`/shop_admin/property_admin_panel/${propertyId}/`, "patch", data);
}

export const deletePropertyService = (propertyId) => {
    return httpService(`/shop_admin/property_admin_panel/${propertyId}/`, "delete");
}

export const getAllpropertyTypesService = () => {
    return httpService("/shop_admin/get_property_type/", "get");
}